import React from 'react'
import { components } from 'react-select'
import { SelectAsync } from '@ztechapps/webui.input'
import { usePurchaseOrderSelect } from '@ztechapps/purchase-order.common'
import { HorizontalStack, ShowIf } from '@ztechapps/webui.util'
import { Col, Stack } from 'react-bootstrap'
import { PurchaseOrderStatus } from '../PurchaseOrderStatus/PurchaseOrderStatusBadge'
import isEmpty from 'lodash/isEmpty'
import { PurchaseOrderWidget } from '../Widget/PurchaseOrderWidget'
import type { PurchaseOrderSelectProps } from '@ztechapps/webui.contract'

export const PurchaseOrderSelect = ({ filter, showInfo, value, ...rest }: PurchaseOrderSelectProps) => {
  const { dataLoadOptions } = usePurchaseOrderSelect()

  return (
    <Stack gap={3}>
      <SelectAsync
        {...{
          components: { Option },
          placeholder: 'Type purchase order code or name',
          labelKey: 'code',
          noOptionsMessage: () => 'Cannot find any purchase orders.',
          dataLoadOptions: dataLoadOptions({ filter }),
          value,
          ...rest,
        }}
      />

      <ShowIf condition={showInfo && !isEmpty(value?._id)}>
        <div>
          <PurchaseOrderWidget code={value?.code} vendor={value?.vendor} status={value?.status} />
        </div>
      </ShowIf>
    </Stack>
  )
}

const Option = ({ data, ...rest }: any) => {
  const name = data?.vendor?.company?.name || '--'
  const code = data?.code
  const status = data?.status
  //always set the isSelected to false so it wont highlight
  return (
    <components.Option {...{ ...rest, data, isSelected: false }}>
      <HorizontalStack gap={2}>
        <div className="flex-shrink-0 text-nowrap">
          <HorizontalStack gap={0}>
            <PurchaseOrderStatus status={status} />
            <div className="fw-bold ">{code}</div>
          </HorizontalStack>
        </div>

        <Col className="text-truncate">
          <small>{name}</small>
        </Col>
      </HorizontalStack>
    </components.Option>
  )
}
